import tutorialWelcomeBg from '../assets/images/tutorial/tutorial-welcome-bg.png';
import tutorialChestBg from '../assets/images/tutorial/tutorial-chest-bg.png';
import tutorialEarnBg from '../assets/images/tutorial/tutorial-earn-bg.png';
import tutorialUpgradeBg from '../assets/images/tutorial/tutorial-upgrade-bg.png';
import tutorialStoreBg from '../assets/images/tutorial/tutorial-store-bg.png';
import tutorialSpinBg from '../assets/images/tutorial/tutorial-spin-bg.png';
import tutorialBoosterBg from '../assets/images/tutorial/tutorial-booster-bg.png';
import tutorialEnergyBg from '../assets/images/tutorial/tutorial-energy-bg.png';
import tutorialMultiplyBg from '../assets/images/tutorial/tutorial-multiply-bg.png';
import tutorialReceiveChestBg from '../assets/images/tutorial/tutorial-receive-chest.png';
import tutorialOpenChestBg from '../assets/images/tutorial/tutorial-open-chest.png';
import tutorialConfirmSubscriptionBg from '../assets/images/tutorial/tutotial-confirm-subscription.png';
import tutorialFailedTaskBg from '../assets/images/tutorial/tutorial-failed-task.png';
import tutorialSkipBg from '../assets/images/tutorial/tutorial-skip-bg.png';
import tutorialFinalBg from '../assets/images/tutorial/tutorial-final-bg.png';

const tutorialImages = [
  tutorialWelcomeBg,
  tutorialChestBg,
  tutorialEarnBg,
  tutorialUpgradeBg,
  tutorialStoreBg,
  tutorialSpinBg,
  tutorialBoosterBg,
  tutorialEnergyBg,
  tutorialMultiplyBg,
  tutorialReceiveChestBg,
  tutorialOpenChestBg,
  tutorialConfirmSubscriptionBg,
  tutorialFailedTaskBg,
  tutorialSkipBg,
  tutorialFinalBg,
];

export function preloadTutorialImages() {
  return Promise.all(
    tutorialImages.map((src) => new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = resolve;
      img.onerror = reject;
    })),
  );
}
